module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar disabled = false;\nvar isFilterField = false;\nif(!!formMapping && !!formMapping.fieldConfig) {\ndisabled        = !!formMapping.fieldConfig.disabled;\nisFilterField   = !!formMapping.fieldConfig.isFilterField;\n}\nconst cssClasses = [];\nif(typeof(additionalCSSClass) !== 'undefined'){\ncssClasses.push(additionalCSSClass);\n}\nif(model.additionalCSSClass) {\ncssClasses.push(model.additionalCSSClass);\n}\nif(config.bootstrapVersion){\ncssClasses.push('form-control')\n}\nif(!model.placeholder && model.placeholderKey){\nmodel.placeholder = __(model.placeholderKey);\n}\nif((model.config || {}).disabled){\ndisabled = true\n}\nvar dataFlag = 'dataDATE';\n%><div class=\"input-group date\"><%\nif(config.bootstrapVersion){\n%><span class=\"input-group-text input-group-addon datepicker-action-icon\"><i class=\"fi fi-calendar\" aria-hidden=\"true\"></i></span><%\n}\n%><input class=\"<%- cssClasses.join(' ') %>\" data-field-type=\"text\" type=\"text\" data-field-code=\"<%- model.fieldCode %>\" data-date=\"<%= isFilterField ? model.filterValue : model[dataFlag] %>\" <%- (disabled ? 'disabled=\"disabled\"' : ''); %>placeholder=\"<%= model.placeholder || '' %>\" /><%\nif(!config.bootstrapVersion){\n%><span class=\"input-group-addon datepicker-action-icon\"><i class=\"fi fi-calendar\" aria-hidden=\"true\"></i></span><%\n}\n%></div>"
  , __filename = "node_modules/frontend-controller/baseComponents/form/fields/air-datetime-picker.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var disabled = false;
var isFilterField = false;
if(!!formMapping && !!formMapping.fieldConfig) {
disabled        = !!formMapping.fieldConfig.disabled;
isFilterField   = !!formMapping.fieldConfig.isFilterField;
}
const cssClasses = [];
if(typeof(additionalCSSClass) !== 'undefined'){
cssClasses.push(additionalCSSClass);
}
if(model.additionalCSSClass) {
cssClasses.push(model.additionalCSSClass);
}
if(config.bootstrapVersion){
cssClasses.push('form-control')
}
if(!model.placeholder && model.placeholderKey){
model.placeholder = __(model.placeholderKey);
}
if((model.config || {}).disabled){
disabled = true
}
var dataFlag = 'dataDATE';

    ; __line = 25
    ; __append("<div class=\"input-group date\">")
    ; 
if(config.bootstrapVersion){

    ; __line = 27
    ; __append("<span class=\"input-group-text input-group-addon datepicker-action-icon\"><i class=\"fi fi-calendar\" aria-hidden=\"true\"></i></span>")
    ; 
}

    ; __line = 29
    ; __append("<input class=\"")
    ; __append( cssClasses.join(' ') )
    ; __append("\" data-field-type=\"text\" type=\"text\" data-field-code=\"")
    ; __append( model.fieldCode )
    ; __append("\" data-date=\"")
    ; __append(escapeFn( isFilterField ? model.filterValue : model[dataFlag] ))
    ; __append("\" ")
    ; __append( (disabled ? 'disabled="disabled"' : '') )
    ; __append("placeholder=\"")
    ; __append(escapeFn( model.placeholder || '' ))
    ; __append("\" />")
    ; 
if(!config.bootstrapVersion){

    ; __line = 31
    ; __append("<span class=\"input-group-addon datepicker-action-icon\"><i class=\"fi fi-calendar\" aria-hidden=\"true\"></i></span>")
    ; 
}

    ; __line = 33
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/form/fields/air-datetime-picker.ejs

}